import * as type from './types';
import axios from '../../../common/config/axios';

export const downlineAgent = (res_data) => (dispatch, getState) => {
    axios.get('downline-agent', {
        params: res_data
    }).then((response) => {
        dispatch({
            type: type.GET_DOWNLINE_AGENT,
            payload: response.data
        });
    }).catch(err => {
        dispatch({
            type: type.GET_DOWNLINE_AGENT,
            payload: err
        });
    });
};

